export default {
    isProduction: true,
    profile: {
        // profile_almashreq || profile_alhammad || profile_unaizah || profile_arrow || profile_arrow_control
        name: 'profile_almashreq',
    },
    defaultErrorStatusCode: 422,
    debug: false,
    phpXdebug: false,
}
